import { Navbar } from '@/ui/components/navigation/Navbar';
import { h, defineComponent } from 'vue';
import { maintenanceBanner } from '@/ui/layouts/MaintenanceBanner';
import FreePlanBanner from '@/ui/layouts/FreePlanBanner.vue';
import { isOnFreePlan } from '@/ui/auth/auth';

export default defineComponent({
  name: 'NavbarLayout',
  setup() {
    return function render() {
      return h('div', [
        h(FreePlanBanner, { props: { display: isOnFreePlan.value } }),
        h(Navbar, { props: { classes: isOnFreePlan.value ? 'navbar__with-top-banner' : '' } }),
        maintenanceBanner({ display: false }),
        h('router-view', { class: isOnFreePlan.value ? 'page-layout page-layout__top-banner' : 'page-layout' }),

        // Used by legacy components
        h('portal-target', {
          class: 'legacy',
          attrs: {
            name: 'modals',
            multiple: true,
          },
        }),
      ]);
    };
  },
});
